import {MenuItem} from '@/store/types';

export function routes () {
    return [
        {
            name: 'pages',
            path: '/paginas',
            component: () => import(/* webpackChunkName: "page-list.component" */ '@/modules/cms/components/PageList.vue'),
            meta: {
                authRequired: true,
                toolbarTitle: 'Páginas del sitio',
                module: 'pages',
                vuex: {
                    loadModules: ['cms'],
                },
            },
        },
        {
            name: 'page',
            path: '/pagina/:id',
            component: () => import(/* webpackChunkName: "page-detail.component" */ '@/modules/cms/components/PageDetail.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Ver/Editar página del sitio',
                module: 'pages.page',
                vuex: {
                    loadModules: ['cms', 'i18n', 'seo', 'media'],
                },
            },
        },
        {
            name: 'cms.menu.list',
            path: '/menus',
            component: () => import(/* webpackChunkName: "menu-list.component" */ '@/modules/cms/modules/menu/components/MenuList.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Lista de menus',
                module: 'menus',
                vuex: {
                    loadModules: ['cms'],
                },
            },
        },
        {
            name: 'cms.menu.detail',
            path: '/menu/:id',
            component: () => import(/* webpackChunkName: "menu-detail.component" */ '@/modules/cms/modules/menu/components/MenuDetail.vue'),
            meta: {
                auth: true,
                toolbarTitle: 'Ver/Editar menú',
                module: 'menus.menu',
                vuex: {
                    loadModules: ['cms', 'blog'],
                },
            },
        },
    ]
}

export function menu (): MenuItem[] {
    return [
        {
            title: 'Páginas',
            icon: 'mdi-sitemap',
            routeName: 'pages',
            requireAuthorization: true,
            permission: '@/pages/admin/page_administration_access',
        },
        {
            title: 'Menús',
            icon: 'mdi-menu',
            routeName: 'cms.menu.list',
            requireAuthorization: true,
            permission: '@/menu/admin',
        },
    ]
}
